import { useEffect, useState } from "react";
import "./Homepage.css";
import "./theme.css";
import ChatBot from "./ChatBot";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

export default function HomePage({ mode = "D" }) {
  const images = [
    "/safety1.jpg",
    "/safety11.jpg",
    "/mobile4.png",
    "/safety6.jpg",
    "/mobile5.png",
    "/safety4.jpg",
    "/safety8.jpg",
    "/mobile6.png",
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const capabilities = [
    {
      number: "01",
      icon: <AssignmentTurnedInOutlinedIcon />,
      title: "Permit to Work",
      text: "Digital permits, multi-level approvals, LOTO integration, validity tracking and controlled closures.",
      image: "/mobile4.png",
      tone: "blue",
    },
    {
      number: "02",
      icon: <SecurityOutlinedIcon />,
      title: "Incidents & Observations",
      text: "Capture photos, root cause analysis, corrective actions and closure verification in real time.",
      image: "/safety4.jpg",
      tone: "green",
    },
    {
      number: "03",
      icon: <FactCheckOutlinedIcon />,
      title: "Audits & Inspections",
      text: "Configurable checklists, compliance scoring, scheduled audits and management dashboards.",
      image: "/mobile5.png",
      tone: "purple",
    },
    {
      number: "04",
      icon: <AnalyticsOutlinedIcon />,
      title: "Analytics & Compliance",
      text: "Live dashboards, audit readiness, compliance tracking and performance insights.",
      image: "/mobile6.png",
      tone: "gold",
    },
  ];

  return (
    <>
      <main className="home-page">
        <section
          className="hero-bg"
          style={{
            backgroundImage: `url(${images[currentImage]})`,
          }}
        >
          <div className="hero-overlay" />
          <div className="hero-grid" />

          <div className="hero-content-wrap">
            <div className="hero-text">
              <div className="hero-eyebrow">
                <span className="hero-eyebrow-dot" />
                SAFETY MANAGEMENT PLATFORM
              </div>

              <h1>
                Digitizing <span>Safety</span>
                <br />
                Empowering Operations
              </h1>

              <p>
                A modern safety management platform that transforms permits,
                inspections, audits, and incident workflows into a seamless,
                compliant, and real-time digital ecosystem.
              </p>

              {mode === "D" && (
                <div className="hero-buttons">
                  <a href="/platform-features" className="btn-primary">
                    Explore Platform
                    <span>→</span>
                  </a>

                  <a href="/contact-us" className="btn-secondary">
                    Request Demo
                  </a>
                </div>
              )}

              <div className="hero-trust">
                <div className="hero-trust-item">
                  <SecurityOutlinedIcon />
                  <div>
                    <strong>Safety</strong>
                    <span>Safer workplaces</span>
                  </div>
                </div>

                <div className="hero-trust-item">
                  <FactCheckOutlinedIcon />
                  <div>
                    <strong>Compliance</strong>
                    <span>Audit ready</span>
                  </div>
                </div>

                <div className="hero-trust-item">
                  <AnalyticsOutlinedIcon />
                  <div>
                    <strong>Real-time</strong>
                    <span>Actionable insights</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-nav hero-nav-left" onClick={prevImage}>
            <ArrowBackIosNewIcon />
          </div>

          <div className="hero-nav hero-nav-right" onClick={nextImage}>
            <ArrowForwardIosIcon />
          </div>

          <div className="hero-dots">
            {images.map((_, index) => (
              <button
                key={index}
                type="button"
                className={
                  index === currentImage ? "hero-dot active" : "hero-dot"
                }
                onClick={() => setCurrentImage(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <div className="hero-scroll">
            <span />
          </div>
        </section>

        <section className="features-pro">
          <div className="capabilities-heading">
            <div className="capabilities-eyebrow">THE PLATFORM</div>

            <h2>
              Key <span>Capabilities</span>
            </h2>

            <div className="capabilities-line">
              <span />
              <span />
            </div>

            <p>
              One connected platform for managing critical safety, compliance,
              and operational workflows.
            </p>
          </div>

          <div className="features-grid">
            {capabilities.map((item) => (
              <article className={`feature-box ${item.tone}`} key={item.number}>
                <div className="feature-content">
                  <div className="feature-top">
                    <span className="feature-number">{item.number}</span>

                    <div className="feature-icon">{item.icon}</div>

                    <a
                      href="/platform-features"
                      className="feature-arrow"
                      aria-label={`Explore ${item.title}`}
                    >
                      →
                    </a>
                  </div>

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>

                  <a href="/platform-features" className="feature-link">
                    Explore
                    <span>→</span>
                  </a>
                </div>

                <div
                  className="feature-media"
                  style={{ backgroundImage: `url(${item.image})` }}
                >
                  <div className="feature-media-overlay" />
                </div>
              </article>
            ))}
          </div>

          <div className="view-all-wrap">
            <a href="/platform-features" className="view-all-button">
              View All Features
              <span>→</span>
            </a>
          </div>
        </section>
      </main>

      <ChatBot />
    </>
  );
}
